import React from 'react';
import ContentLoader from 'react-content-loader';

const FormikRadioTileLoader = () => (
	<ContentLoader
		height={121}
		width={829}
		speed={2}
		backgroundColor="#f3f3f3"
		style={{ border: '1px solid #e0e0e0' }}
		foregroundColor="#ecebeb">
		<circle cx="53" cy="63" r="16" />
		<rect x="76" y="45" rx="0" ry="0" width="54" height="34" />
		<rect x="136" y="50" rx="0" ry="0" width="273" height="23" />
		<rect x="718" y="33" rx="0" ry="0" width="41" height="16" />
		<rect x="718" y="56" rx="0" ry="0" width="82" height="31" />
	</ContentLoader>
);

export default FormikRadioTileLoader;
